__turbopack_context__.v({
  "accordionSlideOverwrite": "link-module-scss-module__CJGXWW__accordionSlideOverwrite",
  "externalLink": "link-module-scss-module__CJGXWW__externalLink",
  "fadeIn": "link-module-scss-module__CJGXWW__fadeIn",
  "fadeOut": "link-module-scss-module__CJGXWW__fadeOut",
  "large": "link-module-scss-module__CJGXWW__large",
  "link": "link-module-scss-module__CJGXWW__link",
  "medium": "link-module-scss-module__CJGXWW__medium",
  "scaleIn": "link-module-scss-module__CJGXWW__scaleIn",
  "scaleOut": "link-module-scss-module__CJGXWW__scaleOut",
  "small": "link-module-scss-module__CJGXWW__small",
  "xsmall": "link-module-scss-module__CJGXWW__xsmall",
  "zoomIn": "link-module-scss-module__CJGXWW__zoomIn",
  "zoomOut": "link-module-scss-module__CJGXWW__zoomOut",
});
